export enum AmendGoodPracticeLoadingState {
    loadingGoodPractice = 'ObservationPage.LoadingGoodPractice',
    savingChanges = 'ObservationPage.SavingChanges',
    submittingCompletion = 'ObservationPage.SubmittingCompletionGoodPractice',
    submittingReOpening = 'ObservationPage.SubmittingReOpeningGoodPractice'
}